import { render, staticRenderFns } from "./PurchTechnology.vue?vue&type=template&id=1f271c41&scoped=true"
import script from "./PurchTechnology.vue?vue&type=script&lang=js"
export * from "./PurchTechnology.vue?vue&type=script&lang=js"
import style0 from "./PurchTechnology.vue?vue&type=style&index=0&id=1f271c41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f271c41",
  null
  
)

export default component.exports